// eslint-disable-next-line import/no-cycle
import APP_ERROR_CODES from '@/assets/data/errorCodes';
import router from '@/router/index';
import { useErrorStore } from '@/stores/components/errorStore';
import { logError } from '@/composables/tracking/useGoogleAnalyticTracking';

export default () => {
  function storeErrorInStore(errorCode, errorMessage, traceId) {
    const error = useErrorStore();
    error.$state.error.code = errorCode;
    error.$state.error.message = errorMessage;
    error.$state.error.traceId = traceId;
  }

  function handleServerErrors(error) {
    const {
      code, message,
    } = error.response.data;

    const errorCode = code;
    const errorMsg = message;
    const traceId = getTraceIdFromHeaders(error.response.headers);
    logError({
      type: 'API', code, message, traceId,
    });

    storeErrorInStore(errorCode, errorMsg, traceId);

    router.push({
      name: 'error',
      params: {
        errorCode,
      },
    });
  }

  function handleMappedErrorResponses(code) {
    const { field, error, callback } = APP_ERROR_CODES.get(code) || {};
    if (callback) {
      callback();
    }

    return field || error ? { field, error } : null;
  }

  function handleErrorInSpaFlow(errorCode, message, traceId) {
    storeErrorInStore(errorCode, message, traceId);

    logError({
      type: 'APP', code: errorCode, message, traceId,
    });

    router.push({
      name: 'error',
      params: {
        errorCode,
      },
    });
  }

  function getTraceIdFromHeaders(headers) {
    const traceIdKey = Object.keys(headers).find((key) => key.toLowerCase() === 'x-tts-trace-id');
    return traceIdKey ? headers[traceIdKey] : null;
  }

  return {
    handleServerErrors,
    handleMappedErrorResponses,
    handleErrorInSpaFlow,
    getTraceIdFromHeaders,
  };
};
